import { Search } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Input } from '@virtual-care/shadcn';

interface SearchProps {
  placeholder?: string;
  className?: string;
  value?: string;
  onChange?: (value: string) => void;
}

function SearchComponent({
  placeholder,
  className,
  value,
  onChange,
}: SearchProps) {
  const { t } = useTranslation();
  const resolvedPlaceholder = placeholder ?? t('common.searchPlaceholder');
  return (
    <>
      <div className="hidden max-w-xl flex-1 md:block">
        <div className="relative">
          <Search className="absolute top-1/2 right-6 h-5 w-5 -translate-y-1/2 transform text-gray-400" />
          <Input
            type="search"
            placeholder={resolvedPlaceholder}
            value={value}
            onChange={(e) => onChange?.(e.target.value)}
            className={`search-input w-full rounded-3xl border-gray-300 py-6 pr-12 pl-4 transition-colors hover:border-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 ${className || ''}`}
          />
        </div>
      </div>

      <div className="mt-3 md:hidden">
        <div className="relative">
          <Search className="absolute top-1/2 right-5 h-4 w-4 -translate-y-1/2 transform text-gray-400" />
          <Input
            type="search"
            placeholder={resolvedPlaceholder}
            value={value}
            onChange={(e) => onChange?.(e.target.value)}
            className={`search-input w-full rounded-3xl border-gray-300 py-2 pr-12 pl-4 transition-colors hover:border-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 ${className || ''}`}
          />
        </div>
      </div>
    </>
  );
}

export default SearchComponent;
